import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { ChunkErrorBoundary } from './components/errors/ChunkErrorBoundary';
import {
  handleChunkLoadError,
  isChunkLoadError,
  resetChunkReloadFlag,
} from './utils/chunkErrorHandling';

// Handle synchronous chunk load errors
window.addEventListener('error', (event) => {
  const isChunkError = isChunkLoadError(event.error, event.message);

  if (isChunkError) {
    if (!handleChunkLoadError()) {
      console.error('Chunk load error persists after reload:', event.error);
    }
  }
});

// Handle promise rejections from dynamic imports
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  const isChunkError = isChunkLoadError(error, error?.message);

  if (isChunkError) {
    event.preventDefault();
    if (!handleChunkLoadError()) {
      console.error('Chunk load error persists after reload:', error);
    }
  }
});

// Clear reload flag on successful load
resetChunkReloadFlag();

createRoot(document.getElementById('root')!).render(
  <ChunkErrorBoundary>
    <App />
  </ChunkErrorBoundary>,
);
